import { render } from "./RegionPavlodar.vue?vue&type=template&id=1d3ff400&ts=true"
import script from "./RegionPavlodar.vue?vue&type=script&lang=ts"
export * from "./RegionPavlodar.vue?vue&type=script&lang=ts"

import "./RegionPavlodar.vue?vue&type=style&index=0&id=1d3ff400&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__